/**
 * CartPopup Component
 * -----------------------------------------------------------
 * A small dropdown panel that appears when the user:
 *  - clicks "Add to Cart" (your logic triggers it)
 *  - hovers over the cart icon (from your navbar)
 *
 * It shows:
 *  - all cart items
 *  - quantity controls
 *  - remove button
 *
 * Uses CartContext for all cart actions.
 */

import React from "react";
import { useCart } from "../../context/CartContext";

const CartPopup = () => {
  const { cart, updateQuantity, removeFromCart } = useCart();

  return (
    <div className="absolute top-full right-0 mt-2 w-72 bg-white/80 backdrop-blur-md border border-[rgba(92,47,47,0.15)] shadow-[0_4px_10px_rgba(92,47,47,0.15)] rounded p-4 z-50">
      <h4 className="text-[#5c2f2f] font-semibold mb-2">Your Cart</h4>

      {cart.length === 0 ? (
        <p className="text-[#a25d5d] text-sm">Your cart is empty.</p>
      ) : (
        <ul className="text-sm space-y-3 max-h-48 overflow-y-auto">
          {cart.map((item) => (
            <li
              key={`${item.id}-${item.variant_id || "no-variant"}`}
              className="flex items-center gap-2"
            >
              <img
                src={item.image_url}
                alt={item.name}
                className="w-10 h-10 object-cover rounded border border-[rgba(92,47,47,0.2)]"
              />

              <div className="flex-1 min-w-0">
                <p className="text-[#7a4343] font-medium truncate">{item.name}</p>

                {item.size_label && (
                  <p className="text-[11px] text-gray-500 mt-0.5">
                    Size: {item.size_label}
                  </p>
                )}

                <input
                  type="number"
                  min={1}
                  value={item.quantity}
                  onChange={(e) =>
                    updateQuantity(
                      item.id,
                      Number(e.target.value),
                      item.variant_id
                    )
                  }
                  className="w-14 mt-1 text-xs border border-[rgba(92,47,47,0.2)] rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-[#a25d5d]"
                />
              </div>

              <button
                onClick={() => removeFromCart(item.id, item.variant_id)}
                className="text-red-500 text-xs font-semibold"
              >
                ✕
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CartPopup;